import {
    StyleSheet
} from "react-native";

const stylesheet = StyleSheet.create({
    headerContent:{
        justifyContent: "space-between",
        flexDirection: "row",
        alignItems: "center"
    },
    iconContent:{
        justifyContent: "space-between",
        flexDirection: "row",
        alignItems: "center"
    },
    otherEventsContent : {
        position: "absolute",
        left: 0,
        right:0,
        bottom: 0,
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
        flex: 1
    },
    eventCard: {
        overflow: "hidden",
        height: 230
    },
    eventStatusBadge: {
        alignSelf: "flex-start",
        flexDirection: "row",
        alignItems: "center"
    },
    eventTitle: {
        maxWidth: "80%",
        textAlign: "left"
    },
    row: {
        flexDirection: "row"
    },
    carouselImage: {
        resizeMode: "contain"
    },
    otherEventCard: {
        flex: 1,
        overflow: "hidden"
    },
    coverImage: {
        resizeMode: "cover",
        height: 200,
        width: "100%"
    },
    otherEventInfoRow: {
        flexDirection: "row",
        alignItems: "center",
        flex: 1
    },
    flex1: {
        flex: 1
    },
    otherEventLogo: {
        width: 50,
        height: 50
    },
    otherEventTitleContainer: {
        alignItems: "flex-start"
    },
    otherEventTitle: {
        maxWidth: "70%"
    },
    otherEventCount: {
        position: "absolute"
    },
    menuHeader: {
        alignItems: "center"
    },
    loadingContainer: {
        alignItems: "center",
        justifyContent: "center"
    }
});
export default stylesheet;
